import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../BaseComponent';
import { ClickButton } from '../ClickButton';
import { ToolsActions } from '../../actions/ToolsActions';
import { SceneStore } from '../../stores/SceneStore';
import { ARisAvailable, startAR } from './ARUtils';

export interface ArButtonState {
    show: boolean;
    elementsInView: boolean;
}
export class ArButton extends BaseComponent<{}, ArButtonState> {
    public componentWillMount(): void {
        this.addStoreListener(SceneStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (!ARisAvailable()) {
            return null;
        }
        return (
            <ClickButton className="smart-button ar-button" callback={this.onClick} disabled={!this.state.elementsInView}>
                <div className="smart-button-label">{t('AR mode')}</div>
            </ClickButton>
        );
    }

    protected onClick = async (): Promise<void> => {
        await startAR();
        ToolsActions.hideSmartExtra();
    };

    protected onChange = () => {
        this.setState({
            elementsInView: SceneStore.getState().elementCount > 0,
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ar/ARButton.tsx